import { Injectable } from "@angular/core";
import { HttpParams } from "@angular/common/http";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { InventoryOfDations } from "../interfaces/vehicle_repossession";

@Injectable()
export class VehicleRepossessionService {
  constructor(private http: HttpClientService) {}

  public getVehicleRepossessions(
    finished = false,
    page_size = 1,
    page_number = 0,
    vin_search?: string,
    lead_search?: string,
    state_filter?: string
  ): Observable<any> {
    let params = new HttpParams()
      .set("finished", finished.toString())
      .set("page_size", page_size.toString())
      .set("page_number", page_number.toString());

    if (vin_search && vin_search.trim()) {
      params = params.set("vin_search", vin_search.trim());
    }
    if (lead_search && lead_search.trim()) {
      params = params.set("lead_search", lead_search.trim());
    }
    if (state_filter && state_filter.trim()) {
      params = params.set("state_filter", state_filter.trim());
    }

    return this.http
      .get("/api/vehicle_repossession", { params })
      .pipe(tap((_) => console.log("VehicleRepossessionService.getVehicleRepossessions: Ok.")));
  }

  public updateFields(id: number, field: string, value: string): Observable<any> {
    const params = {
      id,
      field,
      value,
    };
    return this.http
      .post(`/api/vehicle_repossession/${id}/update_fields`, params)
      .pipe(tap((_) => console.log("VehicleRepossessionService.updateFields: Ok.")));
  }

  public submitInventoryOfDations(id: number, node: string, value: InventoryOfDations): Observable<any> {
    const params = {
      id,
      node,
      value,
    };
    return this.http
      .post(`/api/vehicle_repossession/${id}/inventory_of_dations`, params)
      .pipe(tap((_) => console.log("VehicleRepossessionService.submitInventoryOfDations: Ok.")));
  }

  public submitBillingData(id: number, node: string, value: any): Observable<any> {
    const params = {
      id,
      node,
      value,
    };
    return this.http
      .post(`/api/vehicle_repossession/${id}/billing_data`, params)
      .pipe(tap((_) => console.log("VehicleRepossessionService.submitBillingData: Ok.")));
  }

  public detailsBillingData(id: number): Observable<any> {
    return this.http
      .get(`/api/vehicle_repossession/${id}/details_billing_data`)
      .pipe(tap((_) => console.log("VehicleRepossessionService.detailsBillingData: Ok.")));
  }

  public detailsInventoryOfDations(id: number): Observable<any> {
    return this.http
      .get(`/api/vehicle_repossession/${id}/details_inventory_of_dations`)
      .pipe(tap((_) => console.log("VehicleRepossessionService.detailsInventoryOfDations: Ok.")));
  }

  public bulkDetailsInventoryOfDations(ids: number[]): Observable<any> {
    return this.http
      .post("/api/vehicle_repossession/bulk_details_inventory_of_dations", { ids })
      .pipe(tap((_) => console.log("VehicleRepossessionService.bulkDetailsInventoryOfDations: Ok.")));
  }

  public detailsPaymentValidation(id: number): Observable<any> {
    return this.http
      .get(`/api/vehicle_repossession/${id}/details_payment_validation`)
      .pipe(tap((_) => console.log("VehicleRepossessionService.detailsPaymentValidation: Ok.")));
  }

  public updateRepossessionPaymentStatus(
    documentId: number,
    status: "approved" | "rejected",
    userId: number,
    comment?: string
  ): Observable<any> {
    const params = {
      status,
      user_id: userId,
      ...(comment && { comment }),
    };
    return this.http
      .post(`/api/documents/${documentId}/repossession_payment_status`, params)
      .pipe(tap((_) => console.log("VehicleRepossessionService.updateRepossessionPaymentStatus: Ok.")));
  }

  public createVehicleRepossession(account_id: number, vehicleRepossessionData: any): Observable<any> {
    return this.http
      .post(`/api/accounts/${account_id}/vehicle_repossession`, vehicleRepossessionData)
      .pipe(tap((_) => console.log("VehicleRepossessionService.createVehicleRepossession: Ok.")));
  }
}
